import { render, staticRenderFns } from "./ComprobanteError.vue?vue&type=template&id=7708460e&"
import script from "./ComprobanteError.vue?vue&type=script&lang=js&"
export * from "./ComprobanteError.vue?vue&type=script&lang=js&"
import style0 from "./ComprobanteError.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports